/**
 * @file Запросы инициализации и чтения квоты выбранного хранилища.
 *
 * Инициализация выполняется перед подключением, чтение — при обновлении
 * баланса, а не перед каждой передачей. Числа ответа проверяются в quota.ts.
 */
import { parseTrafficQuota } from './quota.ts'

export async function ensureTrafficQuota(boxId: string, signal: AbortSignal) {
    const response = await fetch('/user-api/customer/traffic/quota', {
        method: 'PUT',
        credentials: 'same-origin',
        headers: { 'X-Box-ID': boxId },
        signal,
    })
    if (!response.ok) throw new Error('Unable to initialize traffic quota')
}

export async function fetchTrafficQuota(boxId: string, signal: AbortSignal) {
    const response = await fetch(
        '/user-api/tunnel-discovery/tunnel-client/traffic/quota/usage',
        {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'X-Tunnel-Client-ID': boxId },
            signal,
        },
    )
    if (!response.ok) throw new Error('Unable to load traffic quota')

    return parseTrafficQuota(await response.json())
}
